'use strict'

import HttpClient from './HttpClient'

class TruckType extends HttpClient {
  getAllTruckType () {
    var url = '/api/truck/type/list'

    return this.sendGet(url, this.headers)
  }
}

export default TruckType
